import { CategorieCritereEnum } from './enums/categorie-critere.enum';
import { TypeOrganismeEnum } from './enums/type-organisme.enum';

export class TypeOrganisme {

    public code: TypeOrganismeEnum;
    public libelle: String;
    public categorie: string = CategorieCritereEnum[CategorieCritereEnum.CATAGORIE_1];

    constructor() {

    }
}
